export default __webpack_public_path__ + "static/media/left-arrow.d5c07ce2.svg";